import _ from 'lodash'
import hooks from '../../hooks/hooks'
import {coreUtils} from '@wix/santa-ds-libs'
import constants from '../../constants/constants'
import structuresComparer from './structuresComparer'
import componentModes from '../../component/componentModes'
import type {Pointer, PS} from '@wix/document-services-types'
import type {DeepStructure} from '@wix/mobile-conversion/src/types'
import {constants as extContants} from '@wix/document-manager-extensions'

const {objectUtils} = coreUtils
const {fullToDisplayedJson} = coreUtils
const NAMESPACES_FOR_PAGES = _.keys(extContants.PAGE_DATA_TYPES).concat(_.values(extContants.VIEW_MODES))

interface FullPageStructure {
    desktop: DeepStructure
    mobile: DeepStructure
}

function initialize(ps: PS) {
    hooks.unregisterHooks([hooks.HOOKS.PUBLISH.BEFORE])
    const mobileMergeSnapshot = ps.extensionAPI.snapshots.getLastSnapshotByTagName(constants.SNAPSHOT_TAGS.MOBILE_MERGE)
    if (!mobileMergeSnapshot) {
        ps.dal.takeSnapshot(constants.SNAPSHOT_TAGS.MOBILE_MERGE)
    }
}

function getChangedPagesPointers(ps: PS): Pointer[] {
    if (!structuresComparer.hasMobileStructure(ps)) {
        return ps.pointers.page.getNonDeletedPagesPointers(true)
    }

    return ps.extensionAPI.page.getNonDeletedChangedPagePointersSinceLastSnapshot(
        constants.SNAPSHOT_TAGS.MOBILE_MERGE,
        _.difference(NAMESPACES_FOR_PAGES, ['fixerVersions'])
    )
}

function getChangedPages(ps: PS): Record<string, FullPageStructure> {
    const pagePointers = getChangedPagesPointers(ps)
    return _.transform(
        pagePointers,
        (acc, pagePointer) => {
            const pageId = pagePointer.id
            const pageComponent = getPage(ps, pageId)
            _.set(acc, pageId, pageComponent)
        },
        {}
    )
}

function getPage(ps: PS, pageId: string): FullPageStructure {
    const pagePointer = ps.pointers.page.getPagePointer(pageId)
    const pageActiveModesMap = componentModes.getMobileActiveModesMap(ps, pageId)
    const activeModesMap = _.set({}, pageId, pageActiveModesMap)
    const pageStructure = ps.dal.full.get(pagePointer)
    const desktop = fullToDisplayedJson.getDisplayedJson(pageStructure, activeModesMap, pageId).structure
    if (desktop.children) {
        desktop.components = desktop.children
        delete desktop.children
    }
    const mobile = objectUtils.cloneDeep(desktop)
    mobile.components = mobile.mobileComponents
    return {desktop, mobile}
}

function commitResults(ps: PS) {
    ps.dal.takeSnapshot(constants.SNAPSHOT_TAGS.MOBILE_MERGE)
}

export default {
    initialize,
    getChangedPages,
    getChangedPagesPointers,
    getPage,
    commitResults
}
